import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Button,
  Container,
  Col,
  Row,
} from 'reactstrap';

import { API, BASE_URL, SEARCH_DELAY_MS } from '../CONST';
import auth from '../helpers/auth';
import { CREATE_MOVIMIENTO, EDIT_MOVIMIENTO, GET_MOVIMIENTO_LINEA } from '../redux-store/constants/action-types';
import { cleanData, getData, postData, putData } from '../redux-store/actions/index';
import GeneralLineForm from './GeneralLineForm';
import LineForm from './LineForm';
import BaseModal from './UI/BaseModal';
import FileTable from "./shared/FileTable";
import FileInput from "./UI/FileInput";

function handleNuevoMonto(monto, variable) {
  const deltaLine = variable !== '' && variable ? variable : 0;
  return monto + deltaLine;
}

function handleFileList(detail) {
  if(detail) {
    return detail.documentos !== null ? detail.documentos : [] ;
  }
  return [];
}

function mapDispatchToProps(dispatch) {
  return {
    apiPost: object => dispatch(postData(object)),
    apiPut: object => dispatch(putData(object)),
    apiGet: object => dispatch(getData(object)),
    apiClean: object => dispatch(cleanData(object)),
  };
}

class EditLineModal extends Component {
  constructor(props) {
    super(props);
    const { linea } = this.props;
    this.adenda = React.createRef();
    this.contrafianza = React.createRef();
    this.filesTable = React.createRef();
    this.state = {
      avales: [],
      awaitingResponse: false,
      deltaLinea: 0,
      enabled: false,
      file: undefined,
      fileList: [],
      isFirst: false,
      justificacion: '',
      limiteContrafianza: 0,
      cambioLimiteContrafianza: 0,
      nuevoMonto: linea.monto || 0,
      movimiento: {},
      detailSuccess: false,
    };
    this.filterOption = this.filterOption.bind(this);
    this.filterOptionsWithDebounce = _.debounce(
      this.filterOption,
      SEARCH_DELAY_MS,
    );
    this.detailSuccess = this.detailSuccess.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleContrafianza = this.handleContrafianza.bind(this);
    this.handleCambioLimiteContrafianza = this.handleCambioLimiteContrafianza.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeltaLinea = this.handleDeltaLinea.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleTextArea = this.handleTextArea.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
  }

  componentDidMount() {
    const { borrador, id, apiClean, isGrupo } = this.props;
    apiClean();
    const url = isGrupo ? `${BASE_URL}${API.lineasGarantiaGrupo}${id}/${API.tieneMovimientos}` :
                          `${BASE_URL}${API.lineasGarantia}${id}/${API.tieneMovimientos}`;
    auth.fetch(url)
      .then(({ result }) => this.setState({ isFirst: !result }));
    if (borrador.id) {
      this.setState({ movimiento: borrador });
      const { apiGet } = this.props;
      if (isGrupo) {
        apiGet({
          url: `${BASE_URL}${API.movimientosGrupo}${borrador.id}/`,
          name: 'linea',
          type: GET_MOVIMIENTO_LINEA,
        })
      }
      else {
        apiGet({
          url: `${BASE_URL}${API.movimientos}${borrador.id}/`,
          name: 'linea',
          type: GET_MOVIMIENTO_LINEA,
        })
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { linea, detail, lineSuccess, success } = this.props;
    if (prevProps.detail !== detail && detail) {
      this.detailSuccess();
    }
    if ((prevProps.success !== success) && success) {
      lineSuccess(linea.nemotecnico);
    }
  }

  filterOption = (inputValue, resolve) => {
    const url = `${BASE_URL}${API.clientes}?roles__term=afianzadogarantia${inputValue.length > 0 ?  `&search=${inputValue}` : ''}`;
    return auth.fetch(url)
      .then(data => {
        const options = data.results.map(node => ({
          label: `${node.rut} - ${node.nombre}`,
          value: node,
        }));
        resolve(options);
      })
  };

  loadOptions = inputValue =>
    new Promise(resolve =>
      this.filterOptionsWithDebounce(inputValue, resolve)
    );

  handleSwitch = (enabled) => {
    this.setState({ enabled });
  };

  buildMovementToSave = () => {
    const { aumento, limite, linea, lineaGarantia, isGrupo } = this.props;
    const {
      avales,
      deltaLinea,
      enabled,
      limiteContrafianza,
      cambioLimiteContrafianza,
      nuevoMonto,
      justificacion,
      isFirst
    } = this.state;

    const config = {
      cambio_monto: Math.abs(deltaLinea),
      documentos_uuids: this.filesTable.current.getNewFilesUuids(),
      justificacion,
      tipo_id: linea.tipo_id,
      tipo_cambio_id: aumento ? 1 : 2,
    };

    if (isGrupo) {
      config.linea_garantia_grupo = lineaGarantia
    }
    else {
      config.linea_garantia = lineaGarantia
    }

    if (linea.nemotecnico === 'linea') {
      if (isFirst && !isGrupo) {
        config.respaldo = {
          cambio_limite_contrafianza: limiteContrafianza || -1,
          contrato_uuid: this.contrafianza.current.getNewFilesUuids(),
          tipo_id: 1,
        };
        if (avales.length && enabled) {
          config.respaldo.avales_ids = avales.map(node => node.value.id);
        }
      } else if (!isGrupo && limite !== -1 && nuevoMonto + cambioLimiteContrafianza > limite) {
          config.respaldo = {
            cambio_limite_contrafianza: cambioLimiteContrafianza,
            contrato_uuid: this.adenda.current.getNewFilesUuids(),
            tipo_id: 2,
          };
        }
    }
    return config
  };

  handleTextArea(e) {
    this.setState({
      justificacion: e.target.value,
    })
  }

  handleDelete(file) {
    const { fileList } = this.state;
    const list = [...fileList];
    this.setState({
      fileList: list.filter(node => node !== file),
    })
  }

  handleDeltaLinea(values) {
    const { aumento, borrador, linea } = this.props;
    const deltaLinea = values.floatValue;
    if (borrador.cambio_monto) {
      const value = aumento ? linea.monto - borrador.cambio_monto : borrador.cambio_monto + linea.monto;
      this.setState({
        deltaLinea,
        nuevoMonto: handleNuevoMonto(value, deltaLinea, aumento),
      })
    } else {
      this.setState({
        deltaLinea,
        nuevoMonto: handleNuevoMonto(linea.monto, deltaLinea, aumento),
      })
    }
  }

  handleContrafianza(values) {
    let limiteContrafianza = values ? -1 : 0;
    if (values.floatValue >= 0) {
      limiteContrafianza = values.floatValue;
    }
    this.setState({ limiteContrafianza })
  }

  handleCambioLimiteContrafianza(values) {
    this.setState({ cambioLimiteContrafianza: values.floatValue })
  }

  handleChange(avales) {
    const { apiClean } = this.props;
    apiClean();
    this.setState({ avales })
  }

  isDisabled() {
    const { aumento } = this.props;
    const { deltaLinea } = this.state;

    return deltaLinea === undefined || (aumento && deltaLinea <= 0) || (!aumento && deltaLinea >= 0);
  }

  detailSuccess() {
    const { detail, aumento } = this.props;
    const avales = detail.respaldo && detail.respaldo.avales
      ? detail.respaldo.avales.map(node => ({ label: `${node.rut} - ${node.nombre}`, value: node }))
      : [];
    const enabled = avales.length > 0;
    this.setState({
      deltaLinea: aumento ? detail.cambio_monto : -detail.cambio_monto ,
      enabled,
      file: detail.respaldo ? detail.respaldo.contrato : {},
      fileList: detail.documentos,
      avales,
      justificacion: detail.justificacion,
      limiteContrafianza: detail.balance.limite_contrafianza,
      cambioLimiteContrafianza: detail.respaldo ? detail.respaldo.cambio_limite_contrafianza : 0,
      detailSuccess: true,
    })
  }

  handleSubmit(e, approve) {
    e.preventDefault();
    this.setState({ awaitingResponse: true });

    const { apiPost, apiPut, isGrupo } = this.props;
    const { fileList, movimiento } = this.state;
    const config = this.buildMovementToSave();
    let promise = null;
    const isGrupoMovimientosURL = isGrupo ? API.movimientosGrupo : API.movimientos;

    // Si el movimiento es nuevo, se crea
    if (!movimiento.id) {
      promise = apiPost({
        url: `${BASE_URL}${isGrupoMovimientosURL}`,
        type: CREATE_MOVIMIENTO,
        unmanaged: approve,
        onFailedReq: () => this.setState({
          awaitingResponse: false
        }),
        config,
      })
    }
    // Si el movimiento es existente, se edita
    else {
      config.documentos_ids = fileList && fileList.map(node => node.id) || null;
      promise = apiPut({
        url: `${BASE_URL}${isGrupoMovimientosURL}${movimiento.id}/`,
        type: EDIT_MOVIMIENTO,
        unmanaged: approve,
        onFailedReq: () => this.setState({
          awaitingResponse: false
        }),
        config,
      })
    }

    // Si se apretó el botón de ejecutar, se ejecuta
    if (promise && approve) {
      promise.then((response) => {
        this.setState({ movimiento: response });
        apiPut({
          url: `${BASE_URL}${isGrupoMovimientosURL}${response.id}/ejecutar/`,
          type: EDIT_MOVIMIENTO,
          callback: () => this.setState({
            awaitingResponse: false
          }),
          config,
        })
      });
    }

    return promise;
  }

  render() {
    const {
      afianzado,
      aumento,
      borrador,
      handleModal,
      detail,
      limite,
      linea,
      loginIdToken,
      modalOpen,
      errorMessages,
      isGrupo,
    } = this.props;
    const {
      avales,
      awaitingResponse,
      deltaLinea,
      enabled,
      file,
      fileList,
      isFirst,
      justificacion,
      limiteContrafianza,
      cambioLimiteContrafianza,
      nuevoMonto,
      detailSuccess,
    } = this.state;

    if (borrador.id && !detailSuccess) {
      return null
    }

    const uploadUrl = `${BASE_URL}${API.upload}/`;
    const downloadUrl = `${BASE_URL}${API.download}/`;
    return(
      <BaseModal
        handleModal={handleModal}
        modalOpen={modalOpen}
        title={`${aumento ? 'Aumento' : 'Disminución'} de ${linea.label} ${isGrupo ? 'de Grupo' : ''}`}
        type="modal-lg"
      >
        <Container className="edit-line-body" fluid>
          {linea.nemotecnico === 'linea' && aumento
          ? (
            <LineForm
              adenda={(
                <FileInput
                  downloadUrl={downloadUrl}
                  file={file}
                  loginIdToken={loginIdToken}
                  ref={this.adenda}
                  uploadUrl={uploadUrl}
                  label="Seleccionar adenda"
                  fileExtensions=".pdf,image/*"
                />
              )}
              afianzado={afianzado}
              avales={avales}
              aumento={aumento}
              contrafianza={(
                <FileInput
                  downloadUrl={downloadUrl}
                  file={file}
                  loginIdToken={loginIdToken}
                  ref={this.contrafianza}
                  uploadUrl={uploadUrl}
                  fileExtensions=".pdf,image/*"
                />
              )}
              enabled={enabled}
              fileTable={(
                <FileTable
                  downloadUrl={downloadUrl}
                  fileList={fileList || []}
                  handleDelete={this.handleDelete}
                  loginIdToken={loginIdToken}
                  ref={this.filesTable}
                  uploadUrl={uploadUrl}
                />
              )}
              handleChange={this.handleChange}
              handleContrafianza={this.handleContrafianza}
              handleCambioLimiteContrafianza={this.handleCambioLimiteContrafianza}
              handleLine={this.handleDeltaLinea}
              handleSwitch={this.handleSwitch}
              handleTextArea={this.handleTextArea}
              isFirst={isFirst}
              justificacion={justificacion}
              limiteContrafianza={limiteContrafianza}
              cambioLimiteContrafianza={cambioLimiteContrafianza}
              limite={limite}
              lineValue={deltaLinea}
              loginIdToken={loginIdToken}
              loadOptions={this.loadOptions}
              nuevoMonto={nuevoMonto}
              isGrupo={isGrupo}
            />
          ) : (
            <GeneralLineForm
              aumento={aumento}
              documents={handleFileList(detail)}
              filesTable={this.filesTable}
              handleLine={this.handleDeltaLinea}
              handleTextArea={this.handleTextArea}
              justificacion={justificacion}
              linea={linea}
              lineValue={deltaLinea}
              nuevoMonto={nuevoMonto}
              fileTable={(
                <FileTable
                  downloadUrl={downloadUrl}
                  fileList={fileList || []}
                  handleDelete={this.handleDelete}
                  loginIdToken={loginIdToken}
                  ref={this.filesTable}
                  uploadUrl={uploadUrl}
                />
              )}
            />
          )}
          {errorMessages && (
            <Row>
              <Col className="error-msg">
                {errorMessages.map(errorMsg => (
                  <div>{`*${errorMsg}`}</div>
                ))}
              </Col>
            </Row>
          )}
          <Row style={{ marginBottom: '0' }}>
            <Col className="text-left">
              <Button
                className="form-button cancelar text-left"
                onClick={handleModal}
              >
                Cancelar
              </Button>
            </Col>
            <Col className="text-right button-container">
              <Button
                className="form-button guardar"
                disabled={awaitingResponse}
                onClick={this.handleSubmit}
              >
                {borrador ? 'Guardar Borrador' : 'Crear Borrador'}
              </Button>
              <Button
                className="form-button confirmar"
                disabled={this.isDisabled() || awaitingResponse}
                onClick={(e) => this.handleSubmit(e, true)}
              >
                Ejecutar
              </Button>
            </Col>
          </Row>
        </Container>
      </BaseModal>
    );
  }
}

const mapStateToProps = state => ({
  clientTable: state.clients.clientTable,
  detail: state.clients.lineDetail,
  loginIdToken: state.login.id_token,
  success: state.clients.successMessage,
  errorMessages: state.clients.errorMessages,
});

EditLineModal.propTypes = {
  aumento: PropTypes.bool.isRequired,
  afianzado: PropTypes.shape({
    nombre: PropTypes.string,
    rut: PropTypes.string,
  }).isRequired,
  borrador: PropTypes.shape({
    cambio_monto: PropTypes.number,
    id: PropTypes.number,
  }),
  apiPost: PropTypes.func.isRequired,
  detail: PropTypes.shape({
    balance: PropTypes.object,
    cambio_monto: PropTypes.number,
    documentos: PropTypes.arrayOf(PropTypes.object),
    justificacion: PropTypes.string,
    respaldo: PropTypes.shape({
      avales: PropTypes.arrayOf(PropTypes.object),
      contrato: PropTypes.string,
      cambio_limite_contrafianza: PropTypes.number,
    }),
  }),
  apiPut: PropTypes.func.isRequired,
  apiGet: PropTypes.func.isRequired,
  handleModal: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
  limite: PropTypes.number,
  linea: PropTypes.shape({
    label: PropTypes.string,
    monto: PropTypes.number,
    nemotecnico: PropTypes.string,
    tipo_id: PropTypes.number,
  }).isRequired,
  lineaGarantia: PropTypes.number.isRequired,
  lineSuccess: PropTypes.func.isRequired,
  loginIdToken: PropTypes.string.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  apiClean: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
  errorMessages: PropTypes.arrayOf(PropTypes.string),
  isGrupo: PropTypes.bool,
};

EditLineModal.defaultProps = {
  errorMessages: null,
  borrador: {},
  limite: 0,
  detail: {},
  isGrupo: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditLineModal);
